import React from 'react';

const LocationSelect = props => {
  const { customers, locations, setCustomerId, setLocationId, getLocations} = props;
  if(customers) console.log(customers);
  return (
    <div className="form__container__content">
      <div className="form__container__content__category">
        <span>Klant en locatie</span>
      </div>
      <div className="form__fields">
        <div className="form__fields__field">
          <span className="form__fields__field__label">Klant</span>
          {customers &&
            <select className="form__fields__field__input" onChange={(e) => {
              setCustomerId(e.target.value);
            }}>
              <option disabled selected>Selecteer een klant</option>
              {customers.customers.map((value, index) => {
                return <option key={index} value={value.id}>{value.name}</option>
              })}
            </select>
          }
        </div>
        {locations &&
          <div className="form__fields__field">
            <span className="form__fields__field__label">Locaties</span>
              <select className="form__fields__field__input" onChange={(e) => setLocationId(e.target.value)}>
                <option disabled selected>Selecteer een locatie</option>
                {locations.locations.map((value, index) => {
                  return <option key={index} value={value.id}>{value.name}</option>
                })}
              </select>
          </div>
        } 
      </div>
    </div>
  )
}

export default LocationSelect;